import React from 'react'
import '../App.css'
import Bodyhomeadminroles from './bodyhomeadminroles'
export class Bodyapphomebodyadminroles extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyhomeadminroles />
                </div>
            </div>
        );
    }
}